import React, { useState } from "react";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import ToolTipComponent from "./ToolTipComponent";
import { capitalizeString } from "../../utils/utilityFunctions/stringUtility";

const ToggleMultiSwitch = ({
  options = [], // [{ label: <Icon />, value: 'list' }]
  onToggle,
  className = "",
  defaultValue,
  paddingHorizontal = "",
  addProp,
}) => {
  const params = new URLSearchParams(window.location.search);
  const ListView = addProp || params.get("listView") || "list";

  const [selected, setSelected] = useState(defaultValue);

  const handleSelect = (value) => {
    setSelected(value);
    if (onToggle) onToggle(value);
  };

  return (
    <div className={`flex   overflow-hidden   ${className}`}>
      {options.map((option, index) => {
        const isActive = ListView === option.value;
        return (
          <ToolTipComponent key={option.value} text={capitalizeString(option.value)} darkMode>
            <button
              key={option.value}
              onClick={() => handleSelect(option.value)}
              className={` h-full w-full flex items-center justify-center duration-150 rounded-full  ${paddingHorizontal} ${
                isActive ? "bg-primary text-white" : "text-[#505E70] "
              }`}
            >
              {option.label}
            </button>
          </ToolTipComponent>
        );
      })}
    </div>
  );
};

export default ToggleMultiSwitch;
